import { createRouter, createWebHistory } from 'vue-router';
import DashboardView from '../views/DashboardView.vue';
import AccountsView from '../views/AccountsView.vue';
import IncomesView from '../views/IncomesView.vue';
import ExpensesView from '../views/ExpensesView.vue';
import LoansView from '../views/LoansView.vue';
import LoginView from '../views/LoginView.vue';
import TransactionsView from '../views/TransactionsView.vue';
import SettingsView from '../views/SettingsView.vue';
import OAuthAuthorizeView from '../views/OAuthAuthorizeView.vue';
import MonthlySummaryView from '../views/MonthlySummaryView.vue';
import ForgotPasswordView from '../views/ForgotPasswordView.vue';
import ResetPasswordView from '../views/ResetPasswordView.vue';

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: LoginView,
    meta: { public: true },
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: ForgotPasswordView,
    meta: { public: true },
  },
  {
    path: '/reset-password',
    name: 'ResetPassword',
    component: ResetPasswordView,
    meta: { public: true },
  },
  {
    path: '/oauth/authorize',
    name: 'OAuthAuthorize',
    component: OAuthAuthorizeView,
    meta: { public: true },
  },
  { path: '/', redirect: '/dashboard' },
  { path: '/dashboard', name: 'Dashboard', component: DashboardView },
  { path: '/monthly', name: 'Monthly', component: MonthlySummaryView },
  { path: '/accounts', name: 'Accounts', component: AccountsView },
  { path: '/incomes', name: 'Incomes', component: IncomesView },
  { path: '/expenses', name: 'Expenses', component: ExpensesView },
  { path: '/loans', name: 'Loans', component: LoansView },
  { path: '/transactions', name: 'Transactions', component: TransactionsView },
  { path: '/settings', name: 'Settings', component: SettingsView },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach(async (to) => {
  const { useAuthStore } = await import('../stores/authStore');
  const authStore = useAuthStore();

  if (!authStore.ready) {
    await authStore.fetchUser();
  }

  if (!to.meta.public && !authStore.isAuthenticated) {
    return { name: 'Login' };
  }
  if (to.name === 'Login' && authStore.isAuthenticated) {
    return { name: 'Dashboard' };
  }
});

export default router;
